import { render, staticRenderFns } from "./main-portfolio.vue?vue&type=template&id=3df8994a&scoped=true&"
import script from "./main-portfolio.vue?vue&type=script&lang=js&"
export * from "./main-portfolio.vue?vue&type=script&lang=js&"
import style0 from "./main-portfolio.vue?vue&type=style&index=0&id=3df8994a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df8994a",
  null
  
)

export default component.exports